import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import styled from 'styled-components';
import { FormControlLabel, Typography, withStyles } from "@material-ui/core";
import { TimePicker } from '@material-ui/pickers';
import Checkbox from "../../Common/CustomCheckbox";
import moment from "moment-timezone";
import t from "../../../languages/pl";
import { dateTimePickerFormat, displayTimeWithoutSecondsFormat } from './../../../utils/staticData';
import withSaveButton from './../../HOC/withSaveButton';
import PaperContainer from '../../Common/PaperContainer';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: ${props => props.height}px;
    width: 100%;
    min-height: 300px;
`;

const useStyles = theme => ({
    timePickers: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: "100%"
    },
    freeDays: {
        width: "70%",
        margin: "auto",
    },
    row: {
        display: "flex",
    },
    column: {
        display: "flex",
        flexDirection: "column",
        width: "50%",
        alignItems: "flex-start",
        marginLeft: theme.spacing(4)
    },
    checkbox: {
        color: "grey"
    }
});

const initialState = {
    godzina_start: moment().unix(),
    godzina_koniec: moment().unix(),
    poniedzialek: false,
    wtorek: false,
    sroda: false,
    czwartek: false,
    piatek: false,
    sobota: false,
    niedziela: false
};

const WorkingsDays = (props) => {
    const { classes, containerHeight, data, onFormDataChange, onChange } = props;
    const [state, setState] = useState(initialState);

    useEffect(() => {
        setState(data);
    }, [data]);

    useEffect(() => {
        console.log(state);

        onFormDataChange(state);
        onChange && onChange(state);
    }, [state]);

    const handleCheckboxChange = e => {
        setState({
            ...state,
            [e.target.name]: e.target.checked
        });
    };

    return (
        <PaperContainer>
            <Typography variant="subtitle1">
                {t.workSchedule}
            </Typography>
            <Container height={containerHeight - 48}>
            <div className={classes.timePickers}>
                <TimePicker
                    label={t.workStartTime}
                    ampm={false}
                    variant="inline"
                    invalidDateMessage={t.invalidTimeFormat}
                    format={displayTimeWithoutSecondsFormat}
                    value={moment.unix(state.godzina_start).format(dateTimePickerFormat)}
                    onChange={(date) => setState({...state, godzina_start: moment(date).utc().unix()})}
                />
                <TimePicker
                    label={t.workFinishTime}
                    ampm={false}
                    variant="inline"
                    invalidDateMessage={t.invalidTimeFormat}
                    format={displayTimeWithoutSecondsFormat}
                    value={moment.unix(state.godzina_koniec).format(dateTimePickerFormat)}
                    onChange={(date) => setState({...state, godzina_koniec: moment(date).utc().unix()})}
                />
            </div>
            <div className={classes.freeDays}>
                <Typography variant="body1">
                    {t.freeDays}
                </Typography>
                    <div className={classes.row}><div className={classes.column}>
                        <FormControlLabel
                            label={t.monday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="poniedzialek"
                            checked={state.poniedzialek}
                            onChange={handleCheckboxChange}
                        />
                        <FormControlLabel
                            label={t.tuesday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="wtorek"
                            checked={state.wtorek}
                            onChange={handleCheckboxChange}
                        />
                        <FormControlLabel
                            label={t.wednesday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="sroda"
                            checked={state.sroda}
                            onChange={handleCheckboxChange}
                        />
                        <FormControlLabel
                            label={t.thursday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="czwartek"
                            checked={state.czwartek}
                            onChange={handleCheckboxChange}
                        />
                    </div>
                    <div className={classes.column}>
                        <FormControlLabel
                            label={t.friday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="piatek"
                            checked={state.piatek}
                            onChange={handleCheckboxChange}
                        />
                        <FormControlLabel
                            label={t.saturday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="sobota"
                            checked={state.sobota}
                            onChange={handleCheckboxChange}
                        />
                        <FormControlLabel
                            label={t.sunday}
                            control={<Checkbox className={classes.checkbox} />}
                            name="niedziela"
                            checked={state.niedziela}
                            onChange={handleCheckboxChange}
                        />
                    </div>
                </div>
            </div>
            </Container>
        </PaperContainer>
    );
};

WorkingsDays.propTypes = {
    containerHeight: PropTypes.number,
    classes: PropTypes.object,
    data: PropTypes.object,
    onChange: PropTypes.func,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withSaveButton,
)(WorkingsDays);
